export default {
  grouping: {
    groupBy: "Agrupar por",
    assetClass: "Classe de ativos",
    currency: "Moeda",
    sector: "Setor",
    region: "Região",
    strategy: "Estratégia",
    uncategorized: "Sem categoria",
  },
  pages: {
    avg: "Média",
    max: "Máx.",
    min: "Mín.",
    footer: {
      page: "Página",
    },
    strategyReport: {
      title: "Proposta de investimento",
      strategyName: (ctx) =>
        `Nome da estratégia: ${ctx.named("portfolioName")} (${ctx.named("currency")})`,
      forRecipient: (ctx) => `Para: ${ctx.named("recipient")}`,
      preparedBy: (ctx) => `Preparado por: ${ctx.named("author")}`,
      period: (ctx) => `Período: ${ctx.named("periodStart")} - ${ctx.named("periodEnd")}`,
    },
    tableOfContents: {
      title: "Índice",
    },
    portfolioComposition: {
      title: "Composição da carteira",
      currencyAlloc: "Alocação por moeda",
      assetClassAlloc: "Alocação por classe de ativos",
      sectorAlloc: "Alocação por setor",
      regionAlloc: "Alocação por região",
      composition: "Composição",
    },
    performanceAnalysis: {
      title: "Análise de desempenho",
      investGrowth: "Crescimento do investimento",
      keyPerfStats: {
        title: "Estatísticas-chave de desempenho",
      },
      histYearyRets: "Retornos anuais históricos",
      histMonthRets: "Retornos mensais históricos",
    },
    riskAnalysis: {
      title: "Análise de risco",
      drawdownAnalysis: "Análise de drawdown",
      drawdownTable: {
        title: "Tabela de drawdown",
        drawdownRank: "Classificação de drawdown",
        startDate: "Data de início",
        troughDate: "Data de vale",
        recoveryDate: "Data de recuperação",
      },
    },
    portfolioHoldings: {
      title: "Posições da carteira",
      topHoldings: {
        title: "Principais posições",
        name: "Nome",
        isin: "ISIN",
        currency: "Moeda",
        assetClass: "Classe de ativos",
        sector: "Setor",
        region: "Região",
        weight: "Peso",
      },
    },
  },
  productPicker: {
    add: "Adicionar",
    searchPlaceholder: "Pesquisar produto...",
  },
  report: {
    backToInputs: "Voltar às entradas",
    downloadReport: "Baixar relatório",
    taskFailed: (ctx) => `A tarefa ${ctx.named("taskName")} falhou: ${ctx.named("reason")}`,
  },
  reportInputs: {
    generateReport: "Gerar relatório",
    fields: {
      general: {
        title: "Geral",
        portfolioName: "Nome da carteira",
        currency: "Moeda",
        author: "Autor",
        recipient: "Destinatário",
        totalCapital: (ctx) => `Capital total (${ctx.named("currency")})`,
        totalCapitalTooltip:
          "Usado para mostrar o montante investido de cada posição na tabela das principais participações, assumindo este capital no final do período. Deixe em branco para ocultar essa coluna.",
      },
      composition: {
        title: "Composição",
        product: "Produto",
        availableFrom: "Disponível a partir de",
        availableUntil: "Disponível até",
        period: "Período",
        fullPeriod: "Período completo",
        weight: "Peso (%)",
        addProduct: "Adicionar produto",
        total: "Total",
        selectOneProduct:
          "Selecione pelo menos um produto na composição para poder selecionar um período.",
        noOverlappingPricePeriod:
          "Os produtos selecionados não têm um histórico de preços em comum, portanto um período de relatório não pode ser selecionado.",
      },
      miscellaneous: {
        title: "Diversos",
        numMonthlyReturns: "Número de anos para retornos mensais históricos",
        numTopHoldings: "Número de posições para as principais participações",
        numTopHoldingsTooltip: "Deixe em branco para obter todas as posições.",
      },
    },
  },
  weightOptimization: {
    portfoliosWeightsAllocation: "Alocação de pesos das carteiras",
    addProduct: "Adicionar produto",
    addPortfolio: "Adicionar carteira",
    total: "Total",
    chartsAndTables: {
      buttonText: "Gerar gráficos e tabelas",
      dataLoadError:
        "Ocorreu um erro ao carregar os dados. Tente novamente ou entre em contato com a Alquant AG se o problema persistir.",
      drawdowns: "Drawdowns",
      performance: "Desempenho",
      period: "Período",
      periodSelectionCondition:
        "Certifique-se de que cada componente com peso diferente de zero em qualquer carteira tenha um produto selecionado.",
      returnToRiskSpace: "Voltar ao espaço risco-retorno",
      selectedPortfolios: "Carteiras selecionadas",
      statistics: "Estatísticas",
      year: "Ano",
      yearlyReturns: "Retornos anuais",
    },
    actionTooltip: {
      restoreDefaultPortfolio: (ctx) =>
        `Restaurar a alocação padrão de «${ctx.named("portfolioName")}».`,
      optimizeWeight: (ctx) =>
        `Otimizar os pesos de «${ctx.named("portfolioName")}» com base nas restrições e objetivos.`,
      cantOptimizeWeight:
        "A otimização requer um produto selecionado para cada linha, além de pelo menos uma posição.",
      usePortfolioToGenerateReport: (ctx) =>
        `Gerar um relatório com a carteira «${ctx.named("portfolioName")}».`,
      cantGenerateReport:
        "A geração do relatório requer um produto selecionado para cada linha e uma alocação total de exatamente 100 %.",
      removePortfolio: (ctx) => `Remover «${ctx.named("portfolioName")}» da comparação.`,
      cantRemovePortfolio: "Pelo menos uma carteira deve permanecer na comparação.",
    },
    optimizationDialog: {
      title: "Parâmetros de otimização",
      objective: "Objetivo",
      period: "Período de otimização",
      bounds: "Limites de alocação",
      addBound: "Adicionar limite",
      singlePosition: "Posição única",
      type: "Tipo",
      target: "Alvo",
      min: "Mín.",
      max: "Máx.",
      buttonText: "Executar otimização",
      optimization: {
        maxRetWithTargetMaxVol: {
          name: "Maximizar retorno (volatilidade anual alvo)",
          targetTitle: "Volatilidade anual máxima",
        },
        maxRetWithTargetPainIndex: {
          name: "Maximizar retorno (pain index alvo)",
          targetTitle: "Pain index máximo",
        },
        maxRetWithTargetMaxDrawdown: {
          name: "Maximizar retorno (drawdown alvo)",
          targetTitle: "Drawdown máximo",
        },
        minVolWithTargetMinRet: {
          name: "Minimizar volatilidade (retorno anual alvo)",
          targetTitle: "Retorno anual mínimo",
        },
        minDrawdownWithTargetMinRet: {
          name: "Minimizar o drawdown máximo (retorno anual alvo)",
          targetTitle: "Retorno anual mínimo",
        },
        maxSharpe: {
          name: "Maximizar índice de Sharpe",
        },
        maxSortino: {
          name: "Maximizar índice de Sortino",
        },
      },
    },
    failedOptimizationDialog: {
      title: "Otimização falhou",
      text: "Nenhuma solução encontrada. As restrições (valores alvo e limites de alocação) podem ser muito restritivas.",
    },
  },
};
